/** Venue hero images keyed by the employee_venue value stored on a fish profile. */
export const EMPLOYEE_VENUE_MAP = [
  {
    label: 'Albion Summit',
    image: '/albion_summit_room.jpeg',
  },
  {
    label: 'Casino Lincoln Park',
    image: '/placeholder_landmark_logo.jpg',
  },
  {
    label: 'Crave Events Group',
    image: '/placeholder_landmark_logo.jpg',
  },
  {
    label: 'Elkins Estates',
    image: '/hotels_elkins_estate.jpg',
  },
  {
    label: 'Farmhouse',
    image: '/placeholder_landmark_logo.jpg',
  },
  {
    label: 'Felina',
    image: '/carousel_felina_jersey_city.jpg',
  },
  {
    label: 'FH/DS',
    image: '/placeholder_landmark_logo.jpg',
  },
  {
    label: 'GRAND COLONIAL OPERATIONS LLC',
    image: '/placeholder_landmark_logo.jpg',
  },
  {
    label: 'Hotel Du Village',
    image: '/hotels_hotel_du_village.jpg',
  },
  {
    label: 'Hudson House',
    image: '/felina_hudson_house.jpg',
  },
  {
    label: 'Landing',
    image: '/placeholder_landmark_logo.jpg',
  },
  {
    label: 'Landmark Event Specialist',
    image: '/placeholder_landmark_logo.jpg',
  },
  {
    label: 'Liberty House',
    image: '/maddy-rose-liberty-house.jpg',
  },
  {
    label: 'Logan Inn',
    image: '/logan_inn.jpg',
  },
  {
    label: 'Mansion',
    image: '/placeholder_landmark_logo.jpg',
  },
  {
    label: 'Mercer Boat House',
    image: '/placeholder_landmark_logo.jpg',
  },
  {
    label: 'Ryland Inn',
    image: '/ryland_inn.jpg',
  },
  {
    label: 'Stone House',
    image: '/stone_house.jpg',
  },
  {
    label: 'Village Hall',
    image: '/village_hall_bar.webp',
  },
];
